import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import UserProvider from "./pages/context/allusers";

ReactDOM.render(
    <UserProvider>
        <React.StrictMode>
            <App />
        </React.StrictMode>
    </UserProvider>,
    document.getElementById("root")
);

if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => {
        navigator.serviceWorker.register("/service-worker.js").catch((error) => {
            console.error("No se pudo registrar el modo instalable:", error);
        });
    });
}
